export default "__VITE_ASSET__BKqoLOU1__"